<div class="mat-page-container">
  <app-table [tableSettings]="tableData"></app-table>
</div>